import VueRouter from 'vue-router';
import routes from './routes';

// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    /*if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }*/
    return { x: 0, y: 0 }
  }
});
router.afterEach(() => {
  document.body.style.overflow = '';
  document.body.classList.remove('overflow-hidden', 'no-scroll', 'modal-open');
});
export default router;
